/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoginUserResponseDto } from './LoginUserResponseDto';
import {
    LoginUserResponseDtoFromJSON,
    LoginUserResponseDtoFromJSONTyped,
    LoginUserResponseDtoToJSON,
    LoginUserResponseDtoToJSONTyped,
} from './LoginUserResponseDto';

/**
 * 
 * @export
 * @interface MeResponseDto
 */
export interface MeResponseDto {
    /**
     * 
     * @type {LoginUserResponseDto}
     * @memberof MeResponseDto
     */
    user: LoginUserResponseDto;
    /**
     * 
     * @type {string}
     * @memberof MeResponseDto
     */
    organizationName?: string;
}

/**
 * Check if a given object implements the MeResponseDto interface.
 */
export function instanceOfMeResponseDto(value: object): value is MeResponseDto {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function MeResponseDtoFromJSON(json: any): MeResponseDto {
    return MeResponseDtoFromJSONTyped(json, false);
}

export function MeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'user': LoginUserResponseDtoFromJSON(json['user']),
        'organizationName': json['organizationName'] == null ? undefined : json['organizationName'],
    };
}

export function MeResponseDtoToJSON(json: any): MeResponseDto {
    return MeResponseDtoToJSONTyped(json, false);
}

export function MeResponseDtoToJSONTyped(value?: MeResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': LoginUserResponseDtoToJSON(value['user']),
        'organizationName': value['organizationName'],
    };
}

